<template>
  <div class="project-content">
    <md-divider />
    <div>
      <studio-project-pieces
        :images="images"
        :index="index"
        @current-image="setCurrentImage"
        @current-index="setCurrentIndex"
      />
    </div>
    <md-dialog
      :md-click-outside-to-close="false"
      :md-active.sync="showModal"
      class="kabs-dialog"
    >
      <div class="md-layout kab-dialog-container">
        <img
          :src="currentImage"
        >
      </div>
      <md-dialog-actions
        class="close-icon"
      >
        <i
          class="material-icons md-size-2x"
          @click="closeDialog"
        >
          clear
        </i>
      </md-dialog-actions>
      <a
        class="prev"
        href="#"
        @click="prev"
      >&#10094;</a>
      <a
        class="next"
        href="#"
        @click="next"
      >&#10095;</a>
    </md-dialog>
  </div>
</template>
<script>
import StudioProjectPieces from './StudioProjectPieces'
export default {
  name: "StudioProject",
  components: {
    StudioProjectPieces
  },
  props: {
    project: {
      type: [Object, Array],
      default: () => {}
    }
  },
  data() {
    return {
      index: 0,
      studioDetails: this.project,
      currentImage: '',
      showModal: false
    }
  },
  computed: {
    images() {
      if (Object.keys(this.studioDetails).length) {
        return this.studioDetails.field_media.reduce((acc, curr) => {
          acc.push(curr.photo)
          return acc
        }, [])
      }
      return []
    }
  },
  watch: {
    project(value) {
      console.log(value)
      this.studioDetails = value
    }
  },
  methods: {
    setCurrentIndex(value) {
      this.index = value
    },
    setCurrentImage(value) {
      this.currentImage = value
      this.showModal = true
    },
    closeDialog() {
      this.currentImage = ''
      this.showModal = false
    },
    next() {
      this.index += 1
      if (this.index === this.images.length) {
        this.index = 0
      }
      this.currentImage = this.images[this.index]
    },
    prev() {
      if (this.index <= 0) {
        this.index = this.images.length - 1
      } else {
        this.index -= 1
      }
      this.currentImage = this.images[this.index]
    }
  }
}
</script>
<style lang="scss">
.kabs-dialog {
  .md-dialog-container {
    flex-flow: inherit !important;
    max-height: inherit !important;
    margin: 100px auto 100px auto !important;
  }
}
</style>
<style lang="scss" scoped>
.project-content { 
  .project-details {
    width: 100%;
    text-align: left;
    margin: 0px 40px auto auto;
    h1 {
      margin: 0;
    }
    p {
      margin-top: 20px;
      margin-bottom: 40px;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.71;
      letter-spacing: normal;
      color: #a1aeb7;
    }
  }
  .image-slider {
    margin-right: 40px;
  }
  .md-divider {
    margin-top: 11px;
  }
}
 .prev, .next {
    cursor: pointer;
    position: absolute;
    top: 40%;
    width: auto;
    padding: 16px;
    color: white;
    font-weight: bold;
    transition: 0.7s ease;
    border-radius: 0 4px 4px 0;
    text-decoration: none;
    user-select: none;
    font-size: 40px;
}
.next {
  right: 0;
}
.prev {
  left: 0;
}
.prev:hover, .next:hover {
  background-color: rgba(0,0,0,0.9);
  text-decoration: none;
}
.kab-dialog-container {
  width: auto !important;
  background-color: transparent !Important;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .kab-dialog-container {
    img {
      width: 100vw;
    }
  }
}
</style>